import { Controller } from "@hotwired/stimulus";

// When timestamp interpretation radio changes, update the csv-mapping-preview controller's mode
// so the preview values refresh to show the interpreted timestamps.
export default class extends Controller {
  updatePreview(event) {
    const mode = event.target.value;
    const previewController = this.application.getControllerForElementAndIdentifier(
      this.element,
      "csv-mapping-preview"
    );
    if (previewController && typeof previewController.interpretationModeValue !== "undefined") {
      previewController.interpretationModeValue = mode;
    }
  }
}
